import { render } from "./ServiciosColectivos.vue?vue&type=template&id=3ed2e9bc&ts=true"
import script from "./ServiciosColectivos.vue?vue&type=script&lang=ts"
export * from "./ServiciosColectivos.vue?vue&type=script&lang=ts"

import "./ServiciosColectivos.vue?vue&type=style&index=0&id=3ed2e9bc&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__